import React from "react";
import {
  Container,
  ContentWrapper,
  CrossIconWrapper,
  WarningIconWrapper,
  Title,
  SubTitle,
  TextWrapper,
  ButtonWrapper,
  Button,
} from "./index.styled";
import { ReactComponent as CrossSolid } from "../../Assets/Icons/CrossSolid.svg";
import { ReactComponent as IonWarning } from "../..//Assets/Icons/IonWarning.svg";
const ResetModal = ({
  title,
  description,
  onProceed,
  onCancel,
  showResetModal,
  isSelectModal = false,
}) => {
  return (
    <Container showResetModal={showResetModal}>
      <ContentWrapper>
        <CrossIconWrapper onClick={onCancel}>
          <CrossSolid />
        </CrossIconWrapper>
        <WarningIconWrapper>
          <IonWarning></IonWarning>
        </WarningIconWrapper>
        <TextWrapper>
          <Title>{title}</Title>
          <SubTitle>{description}</SubTitle>
        </TextWrapper>
        <ButtonWrapper>
          {!isSelectModal && <Button
            color={"#3333333"}
            backgroundColor={"#ffffff"}
            borderColor={"#000000"}
            onClick={onProceed}
          >
            Proceed
          </Button>}
          <Button
            color={isSelectModal ? "#3333333" : "#ffffff"}
            backgroundColor={isSelectModal ? "#ffffff" : "#333333"}
            borderColor={"#333333"}
            onClick={onCancel}
          >
            Cancel
          </Button>
          {isSelectModal && <Button
            color={"#ffffff"}
            backgroundColor={"#333333"}
            borderColor={"#000000"}
            onClick={onProceed}
          >
            Select 20
          </Button>}
        </ButtonWrapper>
      </ContentWrapper>
    </Container>
  );
};

export default ResetModal;
